import { Config } from "../../../configurations/config";

export const CalculatorAPIs = {
  GetMedicalCalculation: `${Config.server_url}${Config.api_prefix}/Reimbursement/MedicalCalculator`,
  GetByYear: `${Config.server_url}${Config.api_prefix}/Reimbursement/MedicalCalculator`,
  ByYearInternetCalculation: `${Config.server_url}${Config.api_prefix}/Reimbursement/InternetCalculator`,
  GetInternetCalculation: `${Config.server_url}${Config.api_prefix}/Reimbursement/InternetCalculator`,
  GetFuelCalculation: `${Config.server_url}${Config.api_prefix}/Reimbursement/FuelCalculator`,
  GetHealthCalculation: `${Config.server_url}${Config.api_prefix}/Reimbursement/HealthCalculator`,
};